import React, { useEffect, useState } from 'react'; 
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu, Spin, message } from 'antd';
import { AiOutlineDashboard } from 'react-icons/ai';
import axios from '../../services/axios';
import { UserOutlined, ProjectOutlined, FileTextOutlined, FileDoneOutlined, BellOutlined, FileSearchOutlined, ProfileOutlined, BankOutlined, CreditCardOutlined, SafetyCertificateOutlined, ContainerOutlined, SolutionOutlined, FileSyncOutlined, PictureOutlined, CalendarOutlined, TeamOutlined  } from '@ant-design/icons';
import useScreenType from 'react-screentype-hook';
import PrivateRoute from '../../layouts/PrivateRoute';
import Header from '../mainComponents/header';
import Dashboard from '../sidebarComponents/dashboard';
// import CreateUsers from '../userManagement/createUsers';
import EditProject from '../projectManagement/editProject';
import UploadDocument from '../documentManagement/uploadDocument'; 
import BulkUploadDocument from '../documentManagement/bulkUpload';
// import DownloadDocument from '../documentManagement/downloadDocument';
import ManageUsers from '../userManagement/manageUsers';
// import CreateProject from '../projectManagement/createProject';
import ViewProject from '../projectManagement/viewProject';
import WorkflowPage from '../workflowTemplate/createWorkflow';
import ViewWorkflow from '../workflowTemplate/viewWorkflow';
import TransmittalForm from '../transmittal/transmittal';
import ViewTransmittal from '../transmittal/viewTransmittal';
import Notifications from '../sidebarComponents/notifications';
import Reports from '../sidebarComponents/reports';
import ProfileManagement from '../sidebarComponents/profileManagement';
import ViewDocument from '../documentManagement/viewDocument';
import LandingPage from '../landingPage';
import DocumentDetails from '../documentDetails';
import PaymentApplication from '../financialDocuments/paymentApplication/paymentApplication';
import ViewPaymentApplication from '../financialDocuments/paymentApplication/viewPaymentApplication';
import DocumentReference from '../financialDocuments/paymentApplication/documentReference';
import PaymentCertification from '../financialDocuments/paymentCertification/paymentCertification';
import ViewPaymentCertification from '../financialDocuments/paymentCertification/viewPaymentCertification';
import PCDocumentReference from '../financialDocuments/paymentCertification/pcDocumentReferemce';
import PaymentReceipt from '../financialDocuments/paymentReceipt/paymentReceipt';
import ViewPaymentReceipt from '../financialDocuments/paymentReceipt/viewPaymentReceipt';
import PRPaymentReference from '../financialDocuments/paymentReceipt/prPaymentReference';
import Variation from '../financialDocuments/variation/variation';
import ViewVariation from '../financialDocuments/variation/viewVariation';
import VariationDocument from '../financialDocuments/variation/variationdocumentReference';
import Claims from '../financialDocuments/claims/claims';
import ViewClaims from '../financialDocuments/claims/viewClaims';
import DocumentClaims from '../financialDocuments/claims/documentClaims';
import ChangeOrder from '../financialDocuments/changeOrder/changeOrder';
import ViewChangeOrder from '../financialDocuments/changeOrder/viewChangeOrder';
import ChangeOrderDocument from '../financialDocuments/changeOrder/changeDocumentReference';
import VariationToContract from '../financialDocuments/variationToContract/variationToContract';
import ViewVariationToContract from '../financialDocuments/variationToContract/viewVariationToContract';
import VariationDocumentReference from '../financialDocuments/variationToContract/variationDocumentReference';
import DashboardFinancial from '../financialDocuments/dashboardFinancial';
import { CONSULTANT_DOCUMENT_CONTROLLER, CONSULTANT_DESIGN_MANAGER, DESIGN_MANAGER, DOCUMENT_CONTROLLER, DRAUGHTSMAN, ENGINEER, HEALTH_SAFETY_ENVIRONMENT, MANAGEMENT, PLANNING_ENGINEER, PROJECT_MANAGER, QAQC_MANAGER, 
    QUANTITY_SURVEYOR, CONSULTANT_ENGINEER, CONSULTANT_SITE_ENGINEER, CONSULTANT_QUANTITY_SURVEYOR, CONSULTANT_SUPERVISOR, CONSULTANT_HEALTH_SAFETY_ENVIRONMENT, CONSULTANT_SITE_ADMINISTRATOR, CONSULTANT_STAFF,
    CONTRACT_MANAGER} from '../../constants/role';
import EditTransmittal from '../transmittal/editTransmittal';
import DraughtsmanDashboard from '../dashboard/draughtsmanDashboard';
import DesignDashboard from '../dashboard/designManagerDashboard';
import ProjectDashboard from '../dashboard/projectManagerDashboard';
import ProCam from '../photos/procam';
import ViewProcam from '../photos/viewProcam';
import CreateSchedule from '../schedulemanagement/createschedule';
import DashboardSchedule from '../schedulemanagement/dashboardschedule';
import ViewScheduleManagement from '../schedulemanagement/viewschedulemanagement';
import TicketManagement from '../sidebarComponents/ticketmanagement';
import ResolveTicket from '../sidebarComponents/resolvedTicket';
import CommercialSetting from '../commercial/setting';
import CommercialDashboard from '../commercial/dashboard';
import ProjectMember from '../projectMembers/projectmembers';

const { Content, Sider } = Layout;

const Home = ({ path }) => {
    const location = useLocation()
    const project = location?.state?.project;
    const [documents, setDocuments] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState([]);
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [collapsed, setCollapsed] = useState(false);

    const screenType = useScreenType();
    const navigate = useNavigate();
    const citriot = JSON.parse(localStorage.getItem('citriot'));
    const role = localStorage.getItem('role')
    const userType = localStorage.getItem('userType');
    
    function getItem(label, key, icon, children, className) {
        return { key, icon, children, label, className };
    }


    useEffect(() => {
        const getOrganisations = async () => {
            try {
                setLoading(true);
                const tempItems = []
                // tempItems.push(
                //     role.includes(DRAUGHTSMAN) ? getItem('Dashboard', `${path}/draughtsman-dashboard`, <AiOutlineDashboard />) :
                //     role.includes(DESIGN_MANAGER) ? getItem('Dashboard', `${path}/designManager-dashboard`, <AiOutlineDashboard />) :
                //     role.includes(PROJECT_MANAGER) ? getItem('Dashboard', `${path}/projectManager-dashboard`, <AiOutlineDashboard />) : getItem('Dashboard', `${path}/projectManager-dashboard`, <AiOutlineDashboard />),
                // )

                tempItems.push(
                    getItem('Dashboard', `${path}/projectManager-dashboard`, <AiOutlineDashboard />)
                )

                // if (!role.includes('Super User')){
                //     tempItems.push(
                //         getItem('Schedule Management', 'sub20', <CalendarOutlined />, [
                //             getItem('Dashboard', `${path}/dashboard-schedule`),
                //             // getItem('Create Schedule', `${path}/create-schedule`)
                //         ])
                //     )
                // }

                const canViewCreateSchedule =
                    role.includes(DOCUMENT_CONTROLLER) ||
                    role.includes(PROJECT_MANAGER) ||
                    role.includes(CONTRACT_MANAGER) ||
                    role.includes(PLANNING_ENGINEER) ||
                    role.includes('Super User');

                    const canViewDashboard = !role.includes('Super User');

                    if (canViewCreateSchedule || canViewDashboard) {
                    const scheduleChildren = [];

                    if (canViewDashboard) {
                        scheduleChildren.push(getItem('Dashboard', `${path}/dashboard-schedule`));
                    }

                    if (canViewCreateSchedule) {
                        scheduleChildren.push(getItem('Create Schedule', `${path}/create-schedule`));
                    }

                    tempItems.push(getItem('Schedule Management', 'sub20', <CalendarOutlined />, scheduleChildren));
                }

                if (role.includes('Super User')) {
                    tempItems.push(
                        getItem('User Management', 'sub1', <UserOutlined />, [
                            getItem('Manage Users', `${path}/manage-users`),
                        ]),
                        getItem('Project Management', 'sub2', <ProjectOutlined />, [
                            getItem('View Projects', `${path}/view-project`),
                        ]),
                        getItem('Workflow Template', 'sub3', <FileDoneOutlined />, [
                            getItem('Create Workflow', `${path}/create-workflow`),
                            getItem('View Workflow', `${path}/view-workflow`),
                        ]),
                        getItem('Transmittal', 'sub4',  <ProfileOutlined />, [
                            getItem('Create Transmittal', `${path}/transmittal-template`),
                            getItem('View Transmittal', `${path}/view-transmittal`)
                        ]),
                    );
                } else if(userType !== 'Consultant') {
                    tempItems.push(
                        getItem('Workflow Template', 'sub5', <FileDoneOutlined />, [
                            getItem('View Workflow', `${path}/view-workflow`),
                        ]),
                    );
                }

                if (!role.includes('Super User')){
                    tempItems.push(
                        getItem('Document Management', 'sub3', <FileTextOutlined />, [
                            (role.includes(DRAUGHTSMAN) || role.includes(ENGINEER) || role.includes(QUANTITY_SURVEYOR) || role.includes(PLANNING_ENGINEER) ||
                            role.includes(HEALTH_SAFETY_ENVIRONMENT) || role.includes(CONSULTANT_ENGINEER) || role.includes(CONSULTANT_SITE_ENGINEER) ||
                            role.includes(CONSULTANT_QUANTITY_SURVEYOR) || role.includes(CONSULTANT_SUPERVISOR) || role.includes(CONSULTANT_HEALTH_SAFETY_ENVIRONMENT) ||
                            role.includes(CONSULTANT_SITE_ADMINISTRATOR) || role.includes(CONSULTANT_STAFF) || role.includes(DOCUMENT_CONTROLLER) || role.includes(CONSULTANT_DOCUMENT_CONTROLLER) ||
                            role.includes(CONSULTANT_DESIGN_MANAGER))&& getItem('Upload Document', `${path}/upload-document`),
                            // getItem('Bulk Upload Document', `${path}/bulk-upload-document`),
                            getItem('View Document', `${path}/view-document`),
                        ]),
                    )
                }

                if (
                    role.includes(QUANTITY_SURVEYOR) ||
                    role.includes(PROJECT_MANAGER) ||
                    role.includes(DOCUMENT_CONTROLLER)
                  ) {
                    const financialChildren = [
                      (role.includes(QUANTITY_SURVEYOR) || role.includes(PROJECT_MANAGER)) &&
                        getItem('Dashboard Financial', `${path}/Dashboard-Financial`),
                  
                      getItem('Payment Application', 'sub11', <CreditCardOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Payment Application', `${path}/payment-application`),
                        getItem('View Payment Application', `${path}/view-payment-application`),
                      ]),
                  
                      getItem('Payment Certification', 'sub12', <SafetyCertificateOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Payment Certification', `${path}/payment-certification`),
                        getItem('View Payment Certification', `${path}/view-payment-certification`),
                      ]),
                  
                      getItem('Payment Receipt', 'sub13', <FileTextOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Payment Receipt', `${path}/payment-receipt`),
                        getItem('View Payment Receipt', `${path}/view-payment-receipt`),
                      ]),
                  
                      getItem('Variation', 'sub14', <ContainerOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Variation', `${path}/Upload-Variation`),
                        getItem('View Variation', `${path}/view-variation`),
                      ]),
                  
                      getItem('Claims', 'sub15', <SolutionOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Claims', `${path}/Upload-Claims`),
                        getItem('View Claims', `${path}/View-Claims`),
                      ]),
                  
                      getItem('Change Order', 'sub16', <FileSyncOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Change Order', `${path}/Upload-Change-Order`),
                        getItem('View Change Order', `${path}/View-Change-Order`),
                      ]),
                  
                      getItem('Variation to Contract', 'sub17', <SolutionOutlined />, [
                        role.includes(QUANTITY_SURVEYOR) &&
                          getItem('Upload Variation Contract', `${path}/Variation-to-Contract`),
                        getItem('View Variation Contract', `${path}/view-Variation-to-Contract`),
                      ]),
                    ].filter(Boolean); 
                    // tempItems.push(
                    //   getItem('Financial Documents', 'sub10', <BankOutlined />, financialChildren)
                    // );
                }

                const showUploadPhotos =
                    role.includes(MANAGEMENT) ||
                    role.includes(PROJECT_MANAGER) ||
                    role.includes(ENGINEER) ||
                    role.includes(QAQC_MANAGER) ||
                    role.includes(PLANNING_ENGINEER) ||
                    role.includes(HEALTH_SAFETY_ENVIRONMENT);

                const proCamChildren = [
                    showUploadPhotos && getItem('Upload Photos', `${path}/procam`),
                    getItem('View Photos', `${path}/view-procam`)
                ].filter(Boolean); 

                tempItems.push(
                    getItem('ProCam', 'sub18', <PictureOutlined />, proCamChildren)
                );

                //commercial module
                tempItems.push(
                    getItem('Commercial', 'sub22', <BankOutlined />, [
                       (role.includes(QUANTITY_SURVEYOR) || role.includes(DOCUMENT_CONTROLLER) || role.includes(CONTRACT_MANAGER) || role.includes(PROJECT_MANAGER)) && getItem('Commercial Setting', `${path}/commercial-setting`),
                        getItem('Commercial Dashboard', `${path}/commercial-dashboard`)
                    ])
                )

                if (!role.includes('Super User')){
                    tempItems.push(
                        getItem('Transmittal', 'sub8', <ProfileOutlined />, [
                            getItem('View Transmittal', `${path}/view-transmittal`)
                        ])
                    );
                }

                if (!role.includes('Super User')){
                    tempItems.push(
                        getItem('Project Member', 'sub19', <TeamOutlined />, [
                            getItem('Project Member', `${path}/project-member`)
                        ])
                    )
                }

                tempItems.push(
                    getItem('Ticket Management', `${path}/ticket-management`, <FileSearchOutlined />),
                    getItem('Notifications', `${path}/notifications`, <BellOutlined />),
                    // getItem('Reports', `${path}/reports`, <BarChartOutlined />),
                    getItem('Profile Management', `${path}/profile-management`, <ProfileOutlined />),
                )
            
                setItems(tempItems);
                setLoading(false);
            } catch (err) {
                setLoading(false);
                message.error(err.response?.data?.msg || 'Something went wrong');
            }
        };

        getOrganisations();

        const currentPath = window.location.pathname;
        if (currentPath === '/home') {
            navigate(`${path}/projectManager-dashboard`);
            setSelectedMenu([`${path}/projectManager-dashboard`]);
        } else {
            setSelectedMenu([currentPath]);
        }
    }, [path, navigate]);

    return (
        <>
            {loading ? (
                <Spin />
            ) : (
                <Layout>
                    <Header auth={citriot.auth} style={{ position: 'fixed', width: '100%', zIndex: 100 }} />
                    <Layout hasSider>
                        <Sider
                            collapsible
                            collapsed={collapsed}
                            onCollapse={setCollapsed}
                            breakpoint="lg"
                            className="bg-white pt-2"
                            width={screenType.isMobile ? 150 : 220}
                            collapsedWidth={screenType.isMobile ? 60 : 80}
                            theme="light"
                            style={{ position: 'fixed', top: 64, bottom: 50, overflowY: 'auto' }}
                        >
                            <Menu
                                className="h-screen border-r-0 itemBoss"
                                mode="inline"
                                selectedKeys={selectedMenu}
                                onSelect={({ key }) => {
                                    navigate(key);
                                    setSelectedMenu([key]);
                                }}
                                defaultSelectedKeys={['/home/dashboard']}
                                items={items}
                            />
                        </Sider>

                        <Content
                            className="bg-[#F7FAFC]"
                            style={
                                screenType.isMobile
                                    ? { marginLeft: collapsed ? 30 : 120, padding: '8px' }
                                    : screenType.isTablet
                                    ? { marginLeft: collapsed ? 30 : 200, padding: '12px' }
                                    : { marginLeft: collapsed ? 48 : 190 }
                            }
                        >
                            <Routes>
                                <Route
                                    path="/dashboard"
                                    element={
                                        <PrivateRoute>
                                            <Dashboard />
                                        </PrivateRoute>
                                    }
                                />
                                <Route path="edit-project" element={<EditProject />} />
                                <Route path="view-project" element={<ViewProject />} />
                                <Route path="manage-users" element={<ManageUsers />} />
                                <Route path="upload-document" element={<UploadDocument />} />
                                <Route path="bulk-upload-document" element={<BulkUploadDocument />} />
                                <Route path="view-document" element={<ViewDocument />} />
                                <Route path="create-workflow" element={<WorkflowPage />} />
                                <Route path="view-workflow" element={<ViewWorkflow />} />
                                <Route path="transmittal-template" element={<TransmittalForm />} />
                                <Route path="view-transmittal" element={<ViewTransmittal />} />
                                <Route path="notifications" element={<Notifications />} />
                                <Route path="reports" element={<Reports />} />
                                <Route path="profile-management" element={<ProfileManagement />} />
                                <Route path="/landing-page" element={<LandingPage />} /> 
                                <Route path="view-document/document/:documentId" element={<DocumentDetails />} />
                                <Route path="payment-application" element={<PaymentApplication />} />
                                <Route path="view-payment-application" element={<ViewPaymentApplication />} />
                                <Route path="view-payment-application/documentReference/:recent" element={<DocumentReference />} />
                                <Route path="payment-certification" element={<PaymentCertification />} />
                                <Route path="view-payment-certification" element={<ViewPaymentCertification />} />
                                <Route path="view-payment-certification/documentReference/:certification" element={<PCDocumentReference />} />
                                <Route path="payment-receipt" element={<PaymentReceipt />} />
                                <Route path="view-payment-receipt" element={<ViewPaymentReceipt />} />
                                <Route path="view-payment-receipt/ipcRef/:receipt" element={<PRPaymentReference />} />
                                <Route path="Upload-Variation" element={<Variation/>} />
                                <Route path="view-variation" element={<ViewVariation/>} />
                                <Route path="view-variation/engineerInstructionReference/:variation" element={<VariationDocument />} />
                                <Route path="Upload-Claims" element={<Claims/>} />
                                <Route path="View-Claims" element={<ViewClaims/>} />
                                <Route path='project-member' element={<ProjectMember/>} />
                                <Route path="view-Claims/documentReference/:claims" element={<DocumentClaims />} />
                                <Route path="Upload-Change-Order" element={<ChangeOrder/>} />
                                <Route path="View-Change-Order" element={<ViewChangeOrder/>} />
                                <Route path="view-Change-Order/changeReference/:changeOrder" element={<ChangeOrderDocument />} />
                                <Route path="Variation-to-Contract" element={<VariationToContract/>} />
                                <Route path="view-Variation-to-Contract" element={<ViewVariationToContract/>} />
                                <Route path="view-Variation-to-Contract/changeReference/:variationContract" element={<VariationDocumentReference />} /> 
                                <Route path="Dashboard-Financial" element={<DashboardFinancial/>} />
                                <Route path='editTransmittal/:transmittalId' element={<EditTransmittal />} />
                                <Route path="draughtsman-dashboard" element={<DraughtsmanDashboard/>} />
                                <Route path="designManager-dashboard" element={<DesignDashboard/>} />
                                <Route path="projectManager-dashboard" element={<ProjectDashboard/>} />
                                <Route path="procam" element={<ProCam/>} />
                                <Route path="view-procam" element={<ViewProcam/>} />
                                <Route path="create-schedule" element={<CreateSchedule />} />
                                <Route path="dashboard-schedule" element={<DashboardSchedule />} />
                                <Route path="create-schedule/fileReference/:fileReference" element={<ViewScheduleManagement />} />
                                <Route path="ticket-management" element={<TicketManagement />} />
                                <Route path="resolved-ticket" element={<ResolveTicket />} />
                                <Route path="commercial-setting" element={<CommercialSetting />} />
                                <Route path="commercial-dashboard" element={<CommercialDashboard />} />
                            </Routes>
                        </Content>
                    </Layout>
                </Layout>
            )}
        </>
    );
};

export default Home;
